import api from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";

const getDefaultState = () => {
  return {
    shopId: "",
    shopName: "",
  };
};

const state = getDefaultState();

const mutations = {
  // AUTH_REQUEST(state){
  //     state.status = 'loading';
  // },
  ENTER_SHOP_MODE(state, payload) {
    state.shopId = payload.shopId;
    state.shopName = payload.shopName;
  },
  RELEASE_SHOP_MODE(state) {
    state.shopId = "";
    state.shopName = "";
    delete state.shopId;
    delete state.shopName;
  },
};

const actions = {
  doEnderShopMode({ commit }, body) {
    return new Promise((reslove, reject) => {
      try {
        api
          .post(apiEndpoints.changeShopMode, body)
          .then((r) => {
            let { shopId } = body;

            commit("ENTER_SHOP_MODE", { ...r.data, shopId });
            reslove({ ...r.data, shopId });
          })
          .catch(() => {
            // console.log("errr post", e);
            reject(1);
          });
      } catch (error) {
        // console.log("error", error);
        reject(1);
      }
    });
  },
  doReleaseShopMode({ commit }) {
    commit("RELEASE_SHOP_MODE");
  },
};
export default {
  state,
  mutations,
  actions,
};
